import { applyTokens } from "../../../utilities/applyTokens.js";
/**
 * Capitalizes the first letter of a string.
 *
 * @param {string} string - The input string.
 * @returns {string} The input string with the first letter capitalized.
 */
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
 * Generates alerts variants styles based on the provided theme tokens.
 *
 * @param tokens - The theme tokens used to generate the alerts variants styles.
 * @returns An object containing the generated alerts variants styles.
 */
function generateAlerts(tokens) {
    const { toast } = tokens.component;
    const alertType = [
        "error",
        "info",
        "success",
        "warning",
        "processing",
    ];
    const alertsObject = alertType.reduce((acc, alertType) => (Object.assign(Object.assign({}, acc), { [`& .MuiAlert-standard${capitalizeFirstLetter(alertType)}`]: {
            "& .MuiAlert-icon": Object.assign({}, applyTokens(toast.alert.icon[alertType])),
        }, [`& .MuiAlert-outlined${capitalizeFirstLetter(alertType)}`]: {
            "& .MuiAlert-icon": Object.assign({}, applyTokens(toast.alert.icon[alertType])),
        }, [`& .MuiAlert-divided${capitalizeFirstLetter(alertType)}`]: {
            "& .MuiAlert-icon": Object.assign({}, applyTokens(toast.alert.icon[alertType])),
        } })), {});
    return alertsObject;
}
const snackbar = (tokens) => {
    const { toast } = tokens.component;
    return {
        MuiSnackbar: {
            defaultProps: {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            },
            styleOverrides: {
                root: Object.assign(Object.assign({ "& .MuiAlert-icon": Object.assign(Object.assign({}, applyTokens(toast.alert.icon)), { height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }) }, generateAlerts(tokens)), { "& .MuiPaper-root": Object.assign(Object.assign({}, applyTokens(toast.alert)), { gap: 0, padding: 0, "& .MuiAlert-message": Object.assign(Object.assign({}, applyTokens(toast.alert.message)), { "& .MuiAlertTitle-root": Object.assign({}, applyTokens(toast.alert.title)) }), "& .MuiAlert-action": Object.assign(Object.assign({}, applyTokens(toast.alert.action)), { justifySelf: "auto" }) }) }),
            },
        },
    };
};
export default snackbar;
//# sourceMappingURL=snackbar.js.map